import type { ClassStudent, ClassStudentOverview, ClassStudentAssignmentPage } from '@module/class';
export type Resource<T> = {
  data: T | null;
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
  requestId: string | null;
};
export const empty = <T>(): Resource<T> => ({
  data: null,
  loading: false,
  loadingMore: false,
  error: null,
  requestId: null,
});
export type ClassStudentDetailState = {
  membership: Resource<ClassStudent>;
  overview: Resource<ClassStudentOverview>;
  assignments: Resource<ClassStudentAssignmentPage>;
};
